"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ExplanationComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null, "Coming soon!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null),
    React.createElement("ol", null,
        React.createElement("li", null, "Number of Points")),
    React.createElement("p", null, "The aim is to get the most Points!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Example")),
    React.createElement("p", null, "Coming soon!"))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/PointsDecreaseWithAttempts/ExplanationComponent.js
// module id = 1031
// module chunks = 0